import React from 'react';
import TreeView from './TreeView';
import isEqual from 'lodash/isEqual';
import { SearchInjector } from 'new/elements/SearchableProvider/SearchInjector';

class Tree extends React.Component {
  constructor(props) {
    super(props);

    this._handleNodePreview = this._handleNodePreview.bind(this);
    this._handleNodeSelected = this._handleNodeSelected.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    //TODO: Temp hack for handling updates on deeply nested objects.
    //Should use immutable here for deep compare
    if (
      isEqual(this.props.selectedNodeId, nextProps.selectedNodeId) &&
      isEqual(this.props.lastUpdatedAt, nextProps.lastUpdatedAt) &&
      isEqual(this.props.isLoadingData, nextProps.isLoadingData)
    ) {
      return false;
    }

    return true;
  }

  render() {
    return (
      <div>
        <div id="tree" className="tree-content-root">
          <SearchInjector>
            <TreeView
              {...this.props}
              selectedNodeId={this.props.selectedNodeId}
              onNodePreview={this._handleNodePreview}
              onNodeSelected={this._handleNodeSelected}
            />
          </SearchInjector>
        </div>
      </div>
    );
  }

  _handleNodePreview(selectedNode) {
    const newSelectionId = this.props.selectedNodeId !== selectedNode.id ? selectedNode.id : null;

    this.props.onNodePreview(selectedNode, newSelectionId);
  }

  _handleNodeSelected(selectedNode) {
    const newSelectionId = this.props.selectedNodeId !== selectedNode.id ? selectedNode.id : null;

    this.props.onNodeSelected(selectedNode, newSelectionId);
  }
}

export default Tree;
